import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import DropFile from '@/components/base/DropFile.vue';
import ResourceImage from '@/components/base/ResourceImage.vue';
import DisableableButton from './buttons/DisableableButton.vue';
import useUploadMedia from '../comp/use-upload-media';
import store from '../store';

type Props = {
  id: string;
  item: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'PublisherLogoUploader',
  props: {
    id: null,
    item: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'input', f: File): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  id: string;
  item: any;
}

const { upload, uploadInProgress } = useUploadMedia();





const file = ref(null);
const isChanged = ref(false);

const defaultUpload = async () => {
  const response = await store.dispatch('content-image/create', {
    data: { description: `publisher: ${props.item.name}`, type: 'ImageV1', realm: 'all' },
  });
  store.dispatch('publishers/update', {
    id: props.item.id,
    data: { name: props.item.name, logoImageID: response.data.id },
  });
  upload(response.data.id, file.value[0]);
};

const changeHandler = (inputFile: any) => {
  if (!inputFile || !inputFile.length) {
    isChanged.value = false;
    return;
  }

  isChanged.value = true;
  file.value = inputFile;
  emits('input', file.value[0]);
};

return { __sfc: true,upload, uploadInProgress, props, emits, file, isChanged, defaultUpload, changeHandler, DropFile, ResourceImage, DisableableButton }
}

})